import { Navigate, NavLink, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth";
import Login from "./pages/Login";
import Batches from "./pages/Batches";
import Shipments from "./pages/Shipments";
import ShipmentDetail from "./pages/ShipmentDetail";
import OzonProducts from "./pages/OzonProducts";
import Help from "./pages/Help";

function Shell() {
  const { user, logout, loading } = useAuth();
  const loc = useLocation();

  if (loading) return <div className="container">Загрузка…</div>;

  if (!user) {
    if (loc.pathname !== "/login") return <Navigate to="/login" replace />;
    return <Login />;
  }

  // «Сканировка» работает только с отгрузками до «Собрана». Остальные разделы
  // ему не нужны и только запутывают — скрываем и из навигации, и из routes.
  const isScanOnly = user.role === "scan_operator";

  return (
    <>
      <nav className="nav">
        <strong>TEKSHER</strong>
        {!isScanOnly && (
          <NavLink to="/batches" className={({ isActive }) => (isActive ? "active" : "")}>
            Партии
          </NavLink>
        )}
        <NavLink to="/shipments" className={({ isActive }) => (isActive ? "active" : "")}>
          Отгрузки
        </NavLink>
        {(user.role === "admin" || user.role === "marketplace_manager") && (
          <NavLink to="/ozon" className={({ isActive }) => (isActive ? "active" : "")}>
            Ozon-справочник
          </NavLink>
        )}
        <NavLink to="/help" className={({ isActive }) => (isActive ? "active" : "")}>
          Инструкция
        </NavLink>
        <span className="spacer" />
        <span className="user">
          {user.name} ({user.role})
        </span>
        <button onClick={logout}>Выйти</button>
      </nav>
      <Routes>
        <Route path="/" element={<Navigate to="/shipments" replace />} />
        <Route path="/login" element={<Navigate to="/shipments" replace />} />
        {!isScanOnly && <Route path="/batches" element={<Batches />} />}
        <Route path="/shipments" element={<Shipments />} />
        <Route path="/shipments/:id" element={<ShipmentDetail />} />
        {!isScanOnly && <Route path="/ozon" element={<OzonProducts />} />}
        <Route path="/help" element={<Help />} />
        <Route path="*" element={<Navigate to="/shipments" replace />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
